import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

export interface SalesTaxClassDto {
  id: string;
  code: string;
  description: string | null;
  taxCategoryId: string;
  taxCategoryCode: string;
  taxCategoryDescription: string | null;
  authorities: TaxAuthorityDto[];
  isDeleted: boolean;
  createdAt: string;
  lastModified: string | null;
  createdByUserId: string | null;
  updatedByUserId: string | null;
}

export interface TaxAuthorityDto {
  id: string;
  name: string;
  code: string;
}

export interface SalesTaxClassCreateDto {
  code: string;
  description: string;
  taxCategoryId: string;
  taxAuthorityIds: string[];
}

export type SalesTaxClassUpdateDto = SalesTaxClassCreateDto;

@Injectable({
  providedIn: 'root'
})
export class SaleTaxClassService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readSalesTaxClasses(): Observable<SalesTaxClassDto[]> {
    return this.#http.getData(`${this.baseUrl}/SalesTaxClass`, { showLoader: true, showMessage: false });
  }

  getSalesTaxClassById(id: string): Observable<SalesTaxClassDto> {
    return this.#http.getData(`${this.baseUrl}/SalesTaxClass/${id}`, { showLoader: true, showMessage: false });
  }

  createSalesTaxClass(payload: SalesTaxClassCreateDto): Observable<SalesTaxClassDto> {
    return this.#http.postData(
      `${this.baseUrl}/SalesTaxClass`,
      { showLoader: true, showMessage: true, message: 'Sales tax class created successfully' },
      payload
    );
  }

  updateSalesTaxClass(id: string, payload: SalesTaxClassUpdateDto): Observable<SalesTaxClassDto> {
    return this.#http.putData(`${this.baseUrl}/SalesTaxClass/${id}`, payload, {
      showLoader: true,
      showMessage: true,
      message: 'Sales tax class updated successfully'
    });
  }

  deleteSalesTaxClass(id: string): Observable<void> {
    return this.#http.deleteData(`${this.baseUrl}/SalesTaxClass/${id}`, {
      showLoader: true,
      showMessage: true,
      message: 'Sales tax class deleted successfully'
    });
  }
}
